import { CreateAccountWizard } from '@/components/common/create-account'
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogDescription,
  ResponsiveDialogHeader,
  ResponsiveDialogTitle,
} from '@/components/common/responsive-dialog'
import { useComponentTranslation } from '@/hooks/use-component-translation'

import locales from './locales'

interface CreateAccountDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onComplete: (userAccountId: string) => void
}

export function CreateAccountDialog({
  open,
  onOpenChange,
  onComplete,
}: CreateAccountDialogProps) {
  const { t } = useComponentTranslation(locales)
  return (
    <ResponsiveDialog open={open} onOpenChange={onOpenChange}>
      <ResponsiveDialogContent size="lg">
        <ResponsiveDialogHeader>
          <ResponsiveDialogTitle>{t('dialogTitle')}</ResponsiveDialogTitle>
          <ResponsiveDialogDescription>
            {t('dialogDescription')}
          </ResponsiveDialogDescription>
        </ResponsiveDialogHeader>
        <CreateAccountWizard
          source="dialog"
          firstAccount={false}
          onComplete={onComplete}
          onClose={() => onOpenChange(false)}
        />
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  )
}
